import { Navigate } from "react-router-dom";
import useToken from "../useToken";
import Header from "../components/header/Header";
import AppConfig from "../common/AppConfig";

function useQuery() {
  return new URLSearchParams(window.location.search);
}

const ProtectedRoute = ({ children, client, isNotFound, multiProductCart }) => {
  const query = useQuery();
  const uniqueId = query.get("u");
  const { token } = useToken();

  if (!token && !uniqueId) {
    return (
      <Navigate to={`${AppConfig.orderFormPath}/login`} replace />
    );
  } else {
    return (
      <>
        {!isNotFound && <Header multiProductCart={multiProductCart} />}
        {children}
      </>
    );
  }
};

export default ProtectedRoute;
